import { css } from 'styled-components';
import { themeColors, themeSizes } from '../../../styles/globalStyleVars';

export const alertsDrawerContentPadding = `${themeSizes.xl} ${themeSizes.smMd} ${themeSizes.xl} ${themeSizes.lg}`;

export const alertsDrawerScrollbarStyles = css`
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-gutter: stable;
  scrollbar-width: thin;
  scrollbar-color: ${themeColors.colorGray_3} transparent;

  &::-webkit-scrollbar {
    width: ${themeSizes.sm};
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${themeColors.colorGray_2};
    border-radius: 999px;
    border: 2px solid transparent;
    background-clip: content-box;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: ${themeColors.colorGray_3};
  }
`;
